export function createKeyStack({ key = 'escape', target = typeof window !== 'undefined' ? window : null } = {}) {
	let callbacks = []
	const normalizedKey = key.toLowerCase()

	function pop() {
		const callback = callbacks.pop()
		callback?.()
	}

	function onKeyDown(event) {
		const code = String(event.code || event.key || '').toLowerCase()

		if (code === normalizedKey || code === `key${normalizedKey}`) {
			pop()
		}
	}

	function push(callback) {
		callbacks.push(callback)
		return () => remove(callback)
	}

	function remove(callback) {
		const index = callbacks.indexOf(callback)

		if (index !== -1) {
			callbacks.splice(index, 1)
		}
	}

	function clear() {
		callbacks = []
	}

	function destroy() {
		clear()
		target?.removeEventListener('keydown', onKeyDown)
	}

	target?.addEventListener('keydown', onKeyDown)

	return { push, pop, remove, clear, destroy }
}
